import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("关闭");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { computed, ref, watch } from 'vue';
import { getSupplierTreeInfo, getSupplierTreeInfoByScienceId } from '@/request';
export default {
  name: 'supplier-tree-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    defaultChecked: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    taskType: [String, Number],
    scienceId: [String, Number]
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const treeData = ref([]);
    const treeRef = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });

    function treeCheck(data, node) {// let checkedNodes = treeRef.value.getCheckedNodes()
      // let targetNodes = checkedNodes.filter(item => item.supplierId == data.supplierId)
      // treeRef.value.setCheckedKeys([])
      // treeRef.value.setCheckedNodes(targetNodes)
    }

    function confirm() {
      visible.value = false;
      console.log(treeRef.value.getCheckedNodes());
      emit('success', treeRef.value.getCheckedNodes());
    }

    const treeProps = ref({
      label: 'text',
      children: 'children'
    });
    watch(() => props.modelValue, v => {
      if (v) getList();
      search.value = '';
    });

    function getList() {
      if (props.taskType == 3) {
        getSupplierTreeInfoByScienceId({
          scienceId: props.scienceId
        }).then(data => {
          if (data !== null && data !== void 0 && data.length) {
            treeData.value = data;

            if (data.length === 1) {
              // treeRef.value.setCheckedNodes([data[0]])
              let target = data[0];
              let defaultCheckedList = [target];

              if (target.children.length && target.children.length > 0) {
                target.children.forEach(subItem => {
                  defaultCheckedList.push(subItem);

                  if (subItem.children && subItem.children.length) {
                    subItem.children.forEach(lastItem => {
                      defaultCheckedList.push(lastItem);
                    });
                  }
                });
              }

              emit('success', defaultCheckedList, data.length);
            }
          }
        });
      } else {
        getSupplierTreeInfo({
          isFilterManufacture: 1
        }).then(data => {
          if (data !== null && data !== void 0 && data.length) {
            // if (props.disabled) {
            //     setDisabled(data)
            // }
            treeData.value = data; // if (data.length === 1) {
            //     // treeRef.value.setCheckedNodes([data[0]])
            //     let target = data[0]
            //     let defaultCheckedList = [target]
            //     if (target.children.length && target.children.length > 0) {
            //         target.children.forEach(subItem => {
            //             defaultCheckedList.push(subItem)
            //             if (subItem.children && subItem.children.length) {
            //                 subItem.children.forEach(lastItem => {
            //                     defaultCheckedList.push(lastItem)
            //                 })
            //             }
            //         })
            //     }
            //     emit('success', defaultCheckedList, data.length)
            // }
          }
        });
      }
    } // 搜索相关


    const search = ref('');

    function filterHandle(value, data, node) {
      console.log(value, data, node);
      if (!value) return true;
      return data.text.includes(value);
    }

    watch(() => search.value, v => {
      treeRef.value.filter(v);
    });

    function setDisabled(list) {
      // let idStr = props.defaultChecked.join()
      list.forEach(item => {
        item.disabled = true;

        if (item.children && item.children.length) {
          setDisabled(item.children);
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_tree = _resolveComponent("el-tree");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "选择团队",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        "destroy-on-close": "",
        width: "600px"
      }, {
        footer: _withCtx(() => [__props.disabled ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        })) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })], 64))]),
        default: _withCtx(() => [!__props.disabled ? (_openBlock(), _createBlock(_component_el_input, {
          key: 0,
          modelValue: search.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value = $event),
          placeholder: "请输入团队名称"
        }, null, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_el_scrollbar, {
          height: "500px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tree, {
            "default-checked-keys": __props.defaultChecked,
            data: treeData.value,
            "node-key": "id",
            ref_key: "treeRef",
            ref: treeRef,
            props: treeProps.value,
            "show-checkbox": "",
            accordion: "",
            "filter-node-method": filterHandle,
            disabled: __props.disabled,
            onCheck: treeCheck
          }, null, 8, ["default-checked-keys", "data", "props", "disabled"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};